// extracted by mini-css-extract-plugin
export default {"productDescription":"Dda-z","featuredDescription":"Eda-z","description":"Fda-z","more":"Gda-z","descriptionSku":"Hda-z"};